import React, { useState } from 'react';
import { VQ } from '../../../../../store/student/types';
import {
  DateInputWithConfirm,
  TextareaWithConfirm,
  getStringFromDate,
  getDateFromString,
  ContinueButton,
  isValidDate,
} from 'shared-components';
import { IDate, ITripToUk } from '../../../../../types';

interface IProps {
  index: number;

  arrivalDate: string;
  departureDate: string;
  purpose: string;

  onSaveAndClose: (trip: ITripToUk) => void;
}

const TripsToUk = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [dArrival, setDArrival] = useState(() => getDateFromString(props.arrivalDate));
  const [dDeparture, setDDeparture] = useState(() => getDateFromString(props.departureDate));
  const [dArrivalError, setDArrivalError] = useState('');
  const [dDepartureError, setDDepartureError] = useState('');
  const [purpose, setPurpose] = useState(props.purpose);

  const saveAndClose = () => {
    onSaveAndClose({
      arrivalDate: getStringFromDate(dArrival),
      departureDate: getStringFromDate(dDeparture),
      purpose,
    });
  };

  const handleOnSaveAndCloseClick = (_event: React.MouseEvent<HTMLButtonElement>) => {
    saveAndClose();
  };

  const validateDate = (dateValue: IDate): string => {
    const { YYYY, DD, MM } = dateValue;

    if (YYYY && DD && MM) {
      const isValid = isValidDate(dateValue);
      if (!isValid) {
        return "Doesn't look like a valid date";
      }
      return '';
    }

    return '';
  };

  const complete =
    dArrival.DD !== null &&
    dArrival.MM !== null &&
    dArrival.YYYY !== null &&
    dDeparture.DD !== null &&
    dDeparture.MM !== null &&
    dDeparture.YYYY !== null &&
    dArrivalError === '' &&
    dDepartureError === '' &&
    purpose !== '';

  return (
    <>
      <DateInputWithConfirm
        key={`${VQ.TRIPS_TO_UK_ARRIVAL_DATE}-${index}`}
        id={`${VQ.TRIPS_TO_UK_ARRIVAL_DATE}-${index}`}
        label={`Date of arrival`}
        value={dArrival}
        errorText={dArrivalError}
        onChangeDD={(evt: any) => setDArrival({ ...dArrival, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDArrival({ ...dArrival, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDArrival({ ...dArrival, YYYY: evt.target.value })}
        onBlur={(_evt: any) => setDArrivalError(validateDate(dArrival))}
      />
      <DateInputWithConfirm
        key={`${VQ.TRIPS_TO_UK_DEPARTURE_DATE}-${index}`}
        id={`${VQ.TRIPS_TO_UK_DEPARTURE_DATE}-${index}`}
        label={`Date of departure`}
        value={dDeparture}
        errorText={dDepartureError}
        onChangeDD={(evt: any) => setDDeparture({ ...dDeparture, DD: evt.target.value })}
        onChangeMM={(evt: any) => setDDeparture({ ...dDeparture, MM: evt.target.value })}
        onChangeYY={(evt: any) => setDDeparture({ ...dDeparture, YYYY: evt.target.value })}
        onBlur={(_evt: any) => setDDepartureError(validateDate(dDeparture))}
      />
      <TextareaWithConfirm
        key={`${VQ.TRIPS_TO_UK_PURPOSE}-${index}`}
        id={`${VQ.TRIPS_TO_UK_PURPOSE}-${index}`}
        value={purpose}
        label={`Purpose of trip`}
        onChange={(evt: any) => setPurpose(evt.currentTarget.value)}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default TripsToUk;
